var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"templates-app-footer text-light w-100 mt-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row align-items-center justify-content-center"},[_c('div',{staticClass:"py-3 col-lg-4 col-md-6 text-center"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo-m60-white.svg")}})])])])])
}]

export { render, staticRenderFns }